import { render, staticRenderFns } from "./FaqCreateEdit.vue?vue&type=template&id=5c1f4a31&scoped=true&"
import script from "./FaqCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FaqCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f4a31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1f4a31')) {
      api.createRecord('5c1f4a31', component.options)
    } else {
      api.reload('5c1f4a31', component.options)
    }
    module.hot.accept("./FaqCreateEdit.vue?vue&type=template&id=5c1f4a31&scoped=true&", function () {
      api.rerender('5c1f4a31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/FAQ/FaqCreateEdit.vue"
export default component.exports